import { createContext, useContext, useState } from "react";

const FeedbackContext = createContext();

export function FeedbackProvider({ children }) {
  const [feedback, setFeedback] = useState(null);

  const showFeedback = (message, success = true) => {
    setFeedback({ message, success });
    setTimeout(() => setFeedback(null), 3000);
  };

  return (
    <FeedbackContext.Provider value={{ feedback, showFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
}

export const useFeedback = () => useContext(FeedbackContext);
